// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8.75 2 L3.25 2 C2.56 2 2 2.56 2 3.25 L2 5.25 C2 5.94 2.56 6.5 3.25 6.5 L8.75 6.5 C9.44 6.5 10 5.94 10 5.25 L10 3.25 C10 2.56 9.44 2 8.75 2 Z',
  'M8.75 9.5 L3.25 9.5 C2.56 9.5 2 10.06 2 10.75 L2 12.75 C2 13.44 2.56 14 3.25 14 L8.75 14 C9.44 14 10 13.44 10 12.75 L10 10.75 C10 10.06 9.44 9.5 8.75 9.5 Z',
  'M14.5 6 L12.5 8 L14.5 10',
];
